import i18n from 'i18next';
import { PencilIcon } from 'lucide-react';
import { type RefObject, useRef } from 'react';
import { useSheeter } from '~/modules/common/sheeter/use-sheeter';
import { UnsavedBadge } from '~/modules/common/unsaved-badge';
import { Button } from '~/modules/ui/button';
import { Card, CardContent } from '~/modules/ui/card';
import type { BaseUser } from '~/modules/user/types';
import { UpdateUserForm } from '~/modules/user/update-user-form';

interface Props {
  user: BaseUser;
  tabIndex: number;
}

export function openUpdateUserSheet(user: BaseUser, buttonRef: RefObject<HTMLButtonElement | null>) {
  const title = i18n.t('c:edit_resource', { resource: i18n.t('c:user').toLowerCase() });
  const createSheet = useSheeter.getState().create;

  createSheet(
    <div className="container">
      <Card className="mb-20">
        <CardContent>
          <UpdateUserForm user={user} sheet />
        </CardContent>
      </Card>
    </div>,
    {
      id: 'update-user',
      triggerRef: buttonRef,
      side: 'right',
      className: 'max-w-full lg:max-w-4xl',
      title,
      titleContent: <UnsavedBadge title={title} />,
    },
  );
}

export function UpdateRow({ user, tabIndex }: Props) {
  const buttonRef = useRef(null);

  return (
    <Button
      ref={buttonRef}
      variant="cell"
      size="cell"
      tabIndex={tabIndex}
      className="justify-center"
      data-tooltip="true"
      data-tooltip-content={i18n.t('c:edit')}
      onClick={() => openUpdateUserSheet(user, buttonRef)}
    >
      <PencilIcon />
    </Button>
  );
}
